module.exports = __webpack_public_path__ + "static/media/menuOpened.aa555e93.svg";